import { Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'app-dialog-confirm',
    templateUrl: './dialog-confirm.component.html',
    styleUrls: ['./dialog-confirm.component.css'],
    standalone: false
})
export class DialogConfirmComponent implements OnInit, OnDestroy {

  protected readonly Array = Array;
  constructor(
    public dialogRef: MatDialogRef<any>,
    @Inject(MAT_DIALOG_DATA) public data: IDialogConfirm,
  ) {}

  // Keyboard Shortcut - Use Esc to clear
  @HostListener('document:keydown', ['$event'])
  protected handleKeydownEvent(event: KeyboardEvent) {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}

export interface IDialogConfirm {
  title: string;
  titleIcon: string;
  message: string | string[];
  negativeText: string;
  positiveText: string;
  alternativeText: string;
}
